<template>
  <div class="wrapper">
    <div class="messageShow" v-show="isShow">
      <span>{{ showMessage }}</span>
    </div>
    <div id="map" ref="map"></div>
    <div class="return">
       <div class="logo" @click="cancel()"></div>
      <div class="title">多边形电子围栏详情</div>
    </div>

    <!-- <div class="dingwei-right">
      <div class="left" @click="resetWrite()">重画</div>
      <div class="right" @click="stopWrite()">结束</div>
    </div> -->
    <div class="content">
      <div class="conn">
        <span>围栏名称</span
        ><span >{{ circleName }}</span>
      </div>
      <div class="conn">
        <span class="dili">地理位置</span
        ><span class="address">{{ address }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { listElectricFence } from "@/api/studentCard.js";

const axios = require("axios");

export default {
  components: {},
  data() {
    return {
      map: "",
      viaMarker: "",
      polygon: "",
      path: [],
      center: [],
      circleName: "",
      address: "",
      status: 1, //1:可以正常画  0：结束画
      search_markers: [],
      accessToken: "",
      studentId: "",
      imei: "",
      isShow: false,
      showMessage: "",
      remainConfigId:""
    };
  },
  mounted() {
    this.initParam();
    this.getMap();
    this.initSliderContent();

    // this.lunxun();
  },
  watch: {
    radiusValue(val, oldVal) {
      if (val != oldVal) {
        if (this.circle != "") {
          var sliderButtons = document.querySelectorAll(
            "div.el-slider__button"
          );
          if (sliderButtons.length > 0) {
            var sliderButton = sliderButtons[0];
            this.circle.setRadius(Number(sliderButton.innerHTML));
          }
        }
      }
    },
  },
  methods: {
    initParam() {
      let urlParam = this.$route.query;
      this.accessToken = urlParam.accessToken;
      this.studentId = urlParam.studentId;
      this.imei = urlParam.imei;
      this.center = new AMap.LngLat(
        urlParam.center.split(",")[0],
        urlParam.center.split(",")[1]
      );
      this.remainConfigId = urlParam.remainConfigId
      this.remainConfigId = urlParam.remainConfigId;
      let params = {
        Authorization: this.accessToken,
        card: this.imei,
        remainType: 3,
      };
      listElectricFence(params).then((res) => {
        // var that = this
        if (res.status == 200) {
          var lists = res.content;
          if (lists.length > 0) {
            for (let i = 0; i < lists.length; i++) {
              var arr = []
              if (this.remainConfigId == lists[i].remainConfigId) {
                var arrList = lists[i].content.split("::");
                for(let j=0;j<arrList.length;j++){
                  arr.push(new AMap.LngLat(
                  arrList[j].split(",")[0],
                  arrList[j].split(",")[1]
                ))
                }
                this.path = arr
                // this.center = new AMap.LngLat(
                //   lists[i].content.split("::")[0].split(",")[1],
                //   lists[i].content.split("::")[0].split(",")[0]
                // );
                this.circleName = lists[i].enclosureDesc;
                this.address = lists[i].enclosureLocation;
                this.getMap();
                break
              }
            }
          }
        }
      });
    },
    savePolygon() {
      console.log(this.path);
      let content = "";
      let arr = this.path;
      for (let i = 0; i < arr.length; i++) {
        console.log(arr[i]);
        if (i == 0) {
          content = content + arr[i].lat + "," + arr[i].lng + "::";
        } else {
          content = content + arr[i][1] + "," + arr[i][0] + "::";
        }
      }
      if(content!=""){
        content = content.substring(0,content.length-2)
      }
      // console.log(content);
      let params={
        Authorization: this.accessToken,
        type: "1",
        contents:content,
        childUserId:this.studentId,
        remark:this.circleName,
        enclosureType:2,
        enclosureLocation:this.address,
        studentCardFactory: 11,
      }
      editElectricFence(params).then((res) => {
        if (res.status == 200) {
          this.isShow = true;
          this.showMessage = "操作成功";
          setTimeout(() => {
            this.isShow = false;
            this.showMessage = "";
          }, 3000);
          this.$router.push({
            path: "/studentCard/dianziweilan?accessToken="+this.accessToken+"&studentId="+this.studentId+"&imei="+this.imei+"&center="+this.center,
         });
        }else {
          this.isShow = true;
          this.showMessage = res.errorMsg;
          setTimeout(() => {
            this.isShow = false;
            this.showMessage = "";
          }, 3000);
        }
      });
    },
    resetWrite() {
      this.status = 1;
      this.path = [];
      this.polygon.setPath(this.path);
      if (this.search_markers.length > 0) {
        for (let i = 0; i < this.search_markers.length; i++) {
          this.search_markers[i].setMap(null);
          // this.search_markers[i] = null
        }
      }
    },
    stopWrite() {
      this.status = 0;
      console.log(JSON.stringify(this.path));
    },
    cancel() {
      this.$router.push({
        path:
          "/studentCard/dianziweilan?accessToken=" +
          this.accessToken +
          "&studentId=" +
          this.studentId +
          "&imei=" +
          this.imei +
          "&center=" +
          this.center,
      });
    },
    lunxun() {
      window.setInterval(() => {
        setTimeout(() => {
          if (this.circle != "") {
            var sliderButtons = document.querySelectorAll(
              "div.el-slider__button"
            );
            if (sliderButtons.length > 0) {
              var sliderButton = sliderButtons[0];
              this.circle.setRadius(Number(sliderButton.innerHTML));
            }
          }
        }, 0);
      }, 1000);
    },
    initSliderContent() {
      setTimeout(() => {}, 1000);

      this.map.setZoom(17);
    },
    getMap() {
      //创建地图
      this.map = new AMap.Map("map", {
        //mapStyle: 'amap://styles/grey',
        center: this.center,
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        zoomToAccuracy: true,
        zoom: 1,
        scrollWheel: false,
        dragEnable: true, //是否可拖动
        resizeEnable: true,
        rotateEnable: false,
      });

      //   this.viaMarker = new AMap.Marker({
      //     map: this.map,
      //     position: this.center,
      //     // 将一张图片的地址设置为 icon
      //     icon: new AMap.Icon({
      //       image: require("../../assets/dingweidian.png"),
      //       size: new AMap.Size(64, 64), //图标所处区域大小
      //       imageSize: new AMap.Size(20, 20), //图标大小
      //     }),
      //     // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
      //     offset: new AMap.Pixel(-10, -13),
      //   });

      this.polygon = new AMap.Polygon({
        path: this.path,
        strokeColor: "#2AD0B5",
        strokeWeight: 1,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        fillColor: "#1791fc",
        zIndex: 50,
      });

      this.map.add(this.polygon);
      // 缩放地图到合适的视野级别
      this.map.setFitView([this.polygon]);

      this.map.setZoom(15)

    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .amap-copyright{
  display: none !important;
}

/deep/ .amap-logo{
    display: none !important;

}
.wrapper {
  // background-color: #c6e926;
  width: 100%;
  position: absolute;
  top: 0rem;
  bottom: 0rem;
  .messageShow {
    height: 0.5rem;
    background-color: #000000;
    opacity: 0.6;
    color: #fff;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    line-height: 0.5rem;
    z-index: 9999;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    border-radius: 3px;
    span {
      margin: 8px;
    }
  }
  #map {
    height: 100%;
    width: 100%;
    position: relative;
  }
  .dingwei-right {
    width: 2.8rem;
    height: 1rem;

    position: fixed;
    bottom: 10px;
    z-index: 999;
    margin-bottom: 3.5rem;
    right: 3%;
    // background-color: #ffffff;
    border-radius: 10px;

    .left {
      background-color: #ffffff;
      color: #666666;
      font-size: 0.3rem;
      text-align: center;
      height: 1rem;
      line-height: 1rem;
      float: left;
      width: 1rem;
      margin: 0 0.2rem;
      border-radius: 50%;
    }
    .right {
      background-color: #ff7600;
      color: #ffffff;
      font-size: 0.3rem;
      text-align: center;
      height: 1rem;
      line-height: 1rem;
      float: left;
      width: 1rem;
      margin: 0 0.2rem;
      border-radius: 50%;
    }
  }

  .content {
    width: 94%;
    height: 2.8rem;
    position: fixed;
    bottom: 10px;
    z-index: 999;
    background-color: #ffffff;
    border-radius: 10px;
    margin: 10px auto 10px 3%;
    // margin-left: 3%;
    .el-input {
      width: 70%;
    }

    /deep/ .el-input__inner {
      border: 0;
    }

    div.conn {
      height: 50%;
      border-bottom: 1px solid #c7c7c7;
      span {
        margin-left: 0.36rem;
        line-height: 1.4rem;
        color: #666666;
        font-size: 0.3rem;
      }
    }

    .dili {
      float: left;
    }

    .address {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 4.56rem;
    }
  }
}
.tig {
  height: 0.72rem;
  background-color: #fff3ed;
  top: 0.94rem;
  width: 100%;
  position: fixed;
  line-height: 0.72rem;
  color: #ff7600;
  font-size: 0.26rem;
  padding-left: 3%;
}

.return {
  height: 0.94rem;
  background-color: #fff;
  top: 0;
  width: 100%;
  position: fixed;
  line-height: 0.94rem;
  // text-align: center;
  z-index: 1000;
  .logo {
    position: relative;
    left: 3%;
    top: 0.28rem;
    content: "";
    // display: inline-block;
    height: 16px;
    width: 16px;
    border-width: 0 0 2px 2px;
    border-color: #222;
    border-style: solid;
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    float: left;
  }
  .title {
    color: #222222;
    font-size: 0.36rem;
    font-weight: bold;
    margin-left: 31%;
  }
}
</style>
